import environment from '@/helpers/Environment'
import axios from 'axios'

const apiUrl = '/api/'
const apiUrlCached = '/cached_api/'

/**
 * Query string parameters (_embeds, at least) maybe included into the endpoint for get requests.
 *
 * @deprecated Use helpers/API.ts
 */
export default {
  createPromise<T extends EntityTypeName>(
    method: string,
    endpoint: string,
    args = {},
    opts: {
      cached?: boolean
      retry?: boolean
    } = {},
  ): Promise<ApiResponse<T>> {
    const sellerId = environment.seller?.id

    if (method === 'GET') {
      args = {
        params: { ...args, _seller: sellerId },
      }
    } else if (sellerId) {
      if (endpoint.includes('?')) {
        endpoint += '&_seller=' + sellerId
      } else {
        endpoint += '?_seller=' + sellerId
      }
    }

    const prefix = opts.cached ? apiUrlCached : apiUrl

    // List of HTTP status codes that should automatically retry.
    const retryCodes = [502]

    let times = opts.retry ? 3 : 1
    let delay = 250

    return new Promise((resolve, reject) => {
      const attempt = () => {
        axios[method.toLowerCase()](prefix + endpoint, args)
          .then((response) => {
            resolve(response.data)
          })
          .catch((e) => {
            times--
            // Retry if cancelled or a retryable status code.
            if (
              (this.isCancelled(e) || (e.response && e.response.status && retryCodes.includes(e.response.status))) &&
              times > 0
            ) {
              // console.debug(`Retrying with delay ${delay}: ${endpoint}`);
              setTimeout(attempt, delay)
              delay *= 2
              return
            }

            reject(e)
          })
      }
      attempt()
    })
  },

  /**
   * @deprecated Use API.ts
   */
  get<T extends EntityTypeName>(endpoint, args?) {
    return this.createPromise<T>('GET', endpoint, args, {
      retry: true,
    })
  },

  /**
   * @deprecated Use API.ts
   */
  getCached<T extends EntityTypeName>(endpoint, args?) {
    return this.createPromise<T>('GET', endpoint, args, {
      cached: true,
      retry: true,
    })
  },

  /**
   * @deprecated Use API.ts
   */
  post<T extends EntityTypeName>(endpoint, args?, opts?) {
    return this.createPromise<T>('POST', endpoint, args, opts)
  },

  /**
   * @deprecated Use API.ts
   */
  patch<T extends EntityTypeName>(endpoint, args?) {
    return this.createPromise<T>('PATCH', endpoint, args)
  },

  /**
   * @deprecated Use API.ts
   */
  delete<T extends EntityTypeName>(endpoint, args?) {
    return this.createPromise<T>('DELETE', endpoint, args)
  },

  isCancelled(e) {
    // Not an Axios error
    if (!e.isAxiosError) {
      return false
    }

    // Firefox, Chromium
    if (e.code && e.code === 'ECONNABORTED') {
      return true
    }

    // Safari
    if (e.message && e.message === 'Network Error') {
      return true
    }

    return false
  },
}
